common.View.create('canvas.blocks.sky.contentAlfa.Block', {

    onDOMLoad() {
        this.initLightbox();
    },

    initLightbox() {
        const images = this.element.find('img');
        const edit = this.element.find('.item').data('edit');

        if(edit) {
            return;
        }

        images.each((index, img) => {
            lightGallery(img, {
                selector: 'this',
            });
        });
    }

});
